



























































































































import { defineComponent, ref } from '@vue/composition-api';
import TabBar from '@/features/ui/tab-bar/TabBar.global.vue';
import TabButton from '@/features/ui/tab-bar/TabButton.global.vue';
import Panel from '@/features/ui/panel/Panel.global.vue';
import Cell from '@/features/ui/layout/Cell.global.vue';
import ProjectCustomerForm from '@/features/app-enterprise-project/views/enterprise-project-create/components/step1/ProjectCustomerForm.vue';
import ProjectBuildingImporter from '@/features/app-enterprise-project/views/enterprise-project-create/components/step1/ProjectBuildingImporter.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import PropertyList from '@/features/app-enterprise-project/views/enterprise-project-create/components/step2/PropertyList.vue';
import PropertyBuildingAssociation from '@/features/app-enterprise-project/views/enterprise-project-create/components/step2/PropertyBuildingAssociation.vue';
import ProjectCreateProductsAndPrices from '@/features/app-enterprise-project/views/enterprise-project-create/components/step3/ProjectCreateProductsAndPrices.vue';
import {
  GetProjectDataUsingIDQuery,
  GetProjectDataUsingIDQueryVariables,
} from './__generated__/GetProjectDataUsingIDQuery';
import {
  GetProjectEditableBuildingsQuery,
  GetProjectEditableBuildingsQueryVariables,
} from './__generated__/GetProjectEditableBuildingsQuery';
import getEditableProjectBuildings from './editable-project-buildings.gql';
import getProjectData from './get-project-draft.gql';
import WizardButton from '@/components/clickables/WizardButton.global.vue';
import Spinner from '@/components/clickables/Spinner.vue';
import EnterpriseBuildingInformation from '@/features/app-enterprise-project/views/enterprise-project-create/components/building-information/EnterpriseBuildingInformation.vue';
import EnterpriseBuildingElevatorAssignment from '@/features/app-enterprise-project/views/enterprise-project-create/components/elevator-assignment/EnterpriseBuildingElevatorAssignment.vue';
import {
  CreatedBuildingMeta,
  EditOptions,
  ProjectBuilding,
} from '@/features/core/store/page-modules/enterprise-project-create/create-module-types';
import ProjectCommentTab from '@/features/app-enterprise-project/views/enterprise-project-create/components/comments/ProjectCommentTab.vue';
import TableSkeleton from '@/features/ui/table/TableSkeleton.global.vue';

interface EnterpriseProjectCreateProps {
  projectReference: string;
  buildingChangeMode?: boolean;
}

interface EnterpriseProjectCreateData {
  step: number;
}

export default defineComponent<
  EnterpriseProjectCreateProps,
  Record<string, unknown>,
  EnterpriseProjectCreateData,
  any,
  any
>({
  components: {
    TableSkeleton,
    EnterpriseBuildingInformation,
    WizardButton,
    PropertyBuildingAssociation,
    PropertyList,
    ProjectBuildingImporter,
    ProjectCustomerForm,
    Cell,
    Panel,
    TabBar,
    TabButton,
    ProjectCreateProductsAndPrices,
    Spinner,
    EnterpriseBuildingElevatorAssignment,
    ProjectCommentTab,
  },
  props: {
    projectReference: {
      type: String,
      required: false,
      default: null,
    },
    buildingChangeMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    projectEditOptions: {
      type: Object,
      required: false,
      default: null,
    },
  },
  setup(props, { emit }) {
    const visible = ref(true);
    const modal = ref(null);

    const show = (): void => {
      visible.value = true;
      emit('show');
    };

    const hide = (): void => {
      visible.value = false;
      emit('hide');
      // Clear the state
      emit('clear');
    };

    return {
      visible,
      modal,
      show,
      hide,
    };
  },
  data() {
    return {
      step: 1,
      formData: null,
      buildingFormData: null,
      customerFormSaving: false,
      loadedExternalId: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters([
      'projectHasElevatorProduct',
      'mainBuildingsWithComments',
      'isCopy',
      'allMainBuildingInformationCompleted',
    ]),
    ...mapState({
      generalInformationCompleted: (state: any) => state.EnterpriseProjectCreateModule.generalInformationCompleted,
      buildingsImportCompleted: (state: any) => state.EnterpriseProjectCreateModule.buildingsImportCompleted,
      propertyInformationCompleted: (state: any) => state.EnterpriseProjectCreateModule.propertyInformationCompleted,
      propertyAssociationCompleted: (state: any) => state.EnterpriseProjectCreateModule.propertyAssociationCompleted,
      newProjectData: (state: any) => state.EnterpriseProjectCreateModule.newProjectData,
      buildings: (state: any) => state.EnterpriseProjectCreateModule.newProjectData.buildings,
      activeStep1BuildingId: (state: any) => state.EnterpriseProjectCreateModule.activeStep1BuildingId,
      activeStep2BuildingId: (state: any) => state.EnterpriseProjectCreateModule.activeStep2BuildingId,
      tab: (state: any) => state.EnterpriseProjectCreateModule.tab,
      saving: (state: any) => state.EnterpriseProjectCreateModule.saving,
      activeBuilding: (state: any) => {
        if (
          state.EnterpriseProjectCreateModule.newProjectData.buildings &&
          state.EnterpriseProjectCreateModule.newProjectData.buildings?.length > 0
        ) {
          return state.EnterpriseProjectCreateModule.newProjectData.buildings.find(
            (building: ProjectBuilding) =>
              building.buildingId === state.EnterpriseProjectCreateModule.activeStep1BuildingId,
          );
        }
      },
      buildingInformationFormValid(state: any) {
        return state.EnterpriseProjectCreateModule.buildingInformationFormValid;
      },
    }),
    // Function to validate the form
    validateForm() {
      if (!this.formData) return false;
      if (
        !this.formData.customerName ||
        !this.validateEmail(this.formData.partnerName) ||
        !this.formData.contractTerm
      ) {
        return false;
      }
      return true;
    },
    // Get the number of buildings that are liegenshaft
    liegenshaftBuildings() {
      return this.buildings.filter((building: ProjectBuilding) => building.liegenshaft);
    },
    // Tab display checks
    showBuildingInformationStep() {
      return this.buildingsImportCompleted && this.liegenshaftBuildings.length > 0;
    },
    showBuildingAssociationStep() {
      if (this.tab === 'buildingContactInformation' || this.tab === 'step1') {
        return false;
      }
      return (
        this.generalInformationCompleted &&
        this.buildingsImportCompleted &&
        this.allMainBuildingInformationCompleted &&
        this.liegenshaftBuildings.length > 0
      );
    },
    showProductsAndPricesStep() {
      if (this.tab === 'buildingContactInformation' || this.tab === 'step1' || this.tab === 'step2') {
        return false;
      }
      return this.propertyAssociationCompleted && this.liegenshaftBuildings.length > 0;
    },
    showElevatorSelectionStep() {
      if (this.tab === 'buildingContactInformation' || this.tab === 'step1' || this.tab === 'step2') {
        return false;
      }
      return this.projectHasElevatorProduct && this.liegenshaftBuildings.length > 0;
    },
    showCommentsStep() {
      if (this.tab === 'buildingContactInformation' || this.tab === 'step1' || this.tab === 'step2') {
        return false;
      }
      return this.mainBuildingsWithComments.length > 0;
    },
  },
  async mounted() {
    this.loading = true;
    if (this.projectReference) {
      await this.setUpdateTab('step1');
      // Make a GraphQL query to populate the state with the project data
      const { data } = await this.$apollo.query({
        query: getProjectData,
        fetchPolicy: 'no-cache',
        variables: {
          projectReference: this.projectReference,
        } as GetProjectDataUsingIDQueryVariables,
      });
      const { projectDraft } = data as GetProjectDataUsingIDQuery;
      if (!projectDraft) {
        return;
      }

      const buildingChangeMode = this.buildingChangeMode;
      let editableBuildings = new Map<string, CreatedBuildingMeta>();

      if (buildingChangeMode) {
        const { data } = await this.$apollo.query({
          query: getEditableProjectBuildings,
          fetchPolicy: 'no-cache',
          variables: {
            projectReference: this.projectReference,
          } as GetProjectEditableBuildingsQueryVariables,
        });

        const { project } = data as GetProjectEditableBuildingsQuery;
        editableBuildings = this.constructEditableBuildingMap(project);
      }

      const projectEditOptions = this.projectEditOptions;
      const editOptions: EditOptions = { ...projectEditOptions, buildingChangeMode, editableBuildings };

      await this.hydrateProjectDraftData({ ...projectDraft.pageContent, ...editOptions });
    } else {
      // If there is no project reference, clear the state
      this.$store.commit('clearState');
      await this.setUpdateTab('step1');
    }
    this.loading = false;
  },
  methods: {
    ...mapActions(['setUpdateTab', 'hydrateProjectDraftData', 'saveToDB', 'setPropertyAssociationCompleted']),
    // Method to trigger form submission in the child component
    submitForm() {
      // Access the form's method triggerSubmit via ref
      if (this.$refs.projectCustomerForm) {
        this.$refs.projectCustomerForm.triggerSubmit();
      }
      // Handle the liegenshaft re-arrangement
      this.$store.commit('configureMainBuildingLinks');
    },
    updateFormData({ formData, loadedExternalId }: { formData: any; loadedExternalId: string }) {
      this.loadedExternalId = loadedExternalId;
      this.formData = formData;
    },
    validateEmail(email: string) {
      // Regular expression pattern for email validation
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // Test the email against the pattern
      return emailPattern.test(email);
    },
    submitBuildingForm() {
      // Access the form's method triggerSubmit via ref
      if (this.$refs.projectBuildingForm) {
        this.$refs.projectBuildingForm.triggerSubmit();
      }
    },
    updateBuildingFormData(formData: any) {
      this.buildingFormData = formData;
    },
    // We put the functions here so that we can call to submit of the form, from outside the component
    validateBuildingInformationForm() {
      if (!this.buildingFormData) return false;
      return (
        this.validateEmail(this.buildingFormData.email) &&
        this.buildingFormData.phoneNumber &&
        this.buildingFormData.firstName &&
        this.buildingFormData.surname &&
        this.buildingFormData.title
      );
    },
    goToProjectList() {
      this.$router.push('/enterprise-project/project-list');
    },
    // Tab
    updateTab(tab: string) {
      this.setUpdateTab(tab);
    },
    goToStep(step: string) {
      this.$store.dispatch('setUpdateTab', step);
      // Save if we go to step 3
      if (step === 'step3') {
        this.$store.dispatch('setPropertyAssociationCompleted', true);
      }
      this.$store.dispatch('saveToDB', { apolloClient: this.$apollo, finalSave: false });
    },
    // Step buttons
    completeCustomerInformationStep() {
      this.$store.dispatch('setBuildingsImportCompleted', true);
      this.goToStep('buildingContactInformation');
    },
    constructEditableBuildingMap(project: GetProjectEditableBuildingsQuery['project']) {
      const editableBuildings = new Map<string, CreatedBuildingMeta>();
      if (!project?.editableBuildings) {
        return editableBuildings;
      }

      for (const building of project.editableBuildings) {
        for (const buildingId of building.draftBuildingIds) {
          editableBuildings.set(buildingId, { buildingReferenceId: building.buildingReferenceId });
        }
      }

      return editableBuildings;
    },
    toggleCustomerFormSaving(saving: boolean) {
      this.customerFormSaving = saving;
    },
    getCommentTabName() {
      if (this.projectHasElevatorProduct) {
        return 'Schritt 6 - Kommentare';
      }
      return 'Schritt 5 - Kommentare';
    },
  },
});
